var name = "@sitecore/engage";
var version = "1.4.3";
var license = "Apache-2.0";
var module = "./esm/src/index.mjs";
var main = "./cjs/src/index.cjs";
var types = "./types/index.d.ts";
var exports = {
	".": {
		types: "./types/index.d.ts",
		"import": "./esm/src/index.mjs",
		require: "./cjs/src/index.cjs"
	}
};
const packageJson = {
	name: name,
	version: version,
	license: license,
	module: module,
	main: main,
	types: types,
	exports: exports
};

export { packageJson as default, exports, license, main, module, name, types, version };
